<script>
  import { Menu } from 'element-ui'
  export default {
    name:'ElMenu',
    extends:Menu
  }
</script>
